import { api } from "..";
import { QueryProps } from "@/types/Api";
import {
  ChatMessagesPaginatedResponse,
  GetChatMessagesPaginatedParams,
} from "./types";

export const getChatMessagesPaginated = async (
  props: QueryProps<GetChatMessagesPaginatedParams>
): Promise<ChatMessagesPaginatedResponse> => {
  const { chatId, ...rest } = props.params;
  const res = await api.client.get(`/chats/${chatId}/messages/paginated`, {
    signal: props.signal,
    params: rest,
  });
  return res.data;
};
